@if (wizardStore.E().form; as formGroup) {
  @if (stepDisabled()) {
    <div class="step-disabled-notification">
      <span class="step-disabled-notification__icon fas fa-info-circle" aria-hidden="true"></span>
      <span class="step-disabled-notification__text">{{ "projectWizard.stepDisabledForLoanPurpose" | translate }}</span>
    </div>
  }
  <form [formGroup]="formGroup">
    <app-card [titleKey]="translationKey + 'formTitle'">
      <app-validated-dropdown
        [label]="translationKey + 'specialPurpose'"
        inputFormControlName="specialPurpose"
        [inputFormControl]="formGroup.controls.specialPurpose"
        [haveEmptyOption]="false"
        [disabled]="stepDisabled()"
      >
        <option [value]="true">{{ "general.yes" | translate }}</option>
        <option [value]="false">{{ "general.no" | translate }}</option>
      </app-validated-dropdown>
      @if (showFormContent()) {
        <hr />
        <div>
          <label class="section-title">{{
            translationKey + "specialContact" | translate
          }}</label>
        </div>

        <app-legal-person-validated-form
          [formGroupInput]="formGroup.controls.legalEntity"
          [showFillDataButton]="true"
          [showBankAccount]="false"
          [disabled]="stepDisabled()"
        />

        <app-person-contact-card
          [title]="'general.contactPerson'"
          [formGroup]="formGroup.controls.contact"
          [showTitle]="true"
          [disabled]="stepDisabled()"
        />
      }
    </app-card>
  </form>
}
